(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wf-offer-links')) {
    customElements.define('wf-offer-links', class extends HTMLElement {
      connectedCallback() {
        if (this.wfLinkClick) return;
        this.wfLinkClick = event => {
          if (event.target.closest('a')) event.stopPropagation();
        };
        this.addEventListener('click', this.wfLinkClick);
      }
    });
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('a[href="#wf-ver-ofertas"]');
    if (!button) return;

    const slideshow = button.closest('slideshow-component');
    const nextButton = slideshow?.querySelector(
      '.slideshow-control--next'
    );

    if (!nextButton) return;

    event.preventDefault();
    event.stopPropagation();
    nextButton.click();
  }, true);
    document.addEventListener('click', function (event) {
    if (window.Shopify?.designMode) return;
    if (event.button !== 0) return;
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;

    const slide = event.target.closest('slideshow-slide');
    const link = slide?.querySelector('.wf-offer-link--more');
    if (!link) return;

    const area = link.getBoundingClientRect();
    if (!area.width || !area.height) return;

    const inside =
      event.clientX >= area.left &&
      event.clientX <= area.right &&
      event.clientY >= area.top &&
      event.clientY <= area.bottom;

    if (!inside) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(link.href);
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wf-quantity-total')) {
    customElements.define('wf-quantity-total', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('.shopify-section');
        if (!this.scope) return;

        this.refresh = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateTotal());
        };

        ['input', 'change', 'click'].forEach((eventName) => {
          this.scope.addEventListener(eventName, this.refresh);
        });

        this.refresh();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (!this.scope || !this.refresh) return;

        ['input', 'change', 'click'].forEach((eventName) => {
          this.scope.removeEventListener(eventName, this.refresh);
        });
      }

      updateTotal() {
        const input = this.scope.querySelector(
          'quantity-selector-component input[name="quantity"]'
        );
        if (!input) return;

        const quantity = Number(input.value);
        const price = Number(this.dataset.price);
        const valid = Number.isInteger(quantity)
          && quantity > 0
          && input.validity.valid
          && Number.isFinite(price);

        this.querySelector('[data-wf-quantity]').textContent =
          valid ? String(quantity) : '—';

        if (!valid) {
          ['base', 'tax', 'total'].forEach((name) => {
            this.querySelector(`[data-wf-${name}]`).textContent = '—';
          });
          return;
        }

        const total = Math.round(price * quantity);
        const base = Math.round(total / 1.21);
        const tax = total - base;
        const formatter = new Intl.NumberFormat('es-ES', {
          style: 'currency',
          currency: this.dataset.currency || 'EUR'
        });

        const amounts = { base, tax, total };

        Object.entries(amounts).forEach(([name, amount]) => {
          this.querySelector(`[data-wf-${name}]`).textContent =
            formatter.format(amount / 100);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
